export default __webpack_public_path__ + "3c5119d9e3335af8ddf1885c3fdd9755.svg";